import { useMutation } from 'react-query';
import { toastr } from 'react-redux-toastr';
import HudVoucherService from '../../services/hudVoucherService';
import messages from './messages';

const useMoveTenantEventToNextVoucherMutation = ({
  organizationId,
  propertyId,
  hudVoucherId,
  effectiveSubmissionStatus,
  intl,
  invalidateRegularAssistanceQueries,
  onSubmittedVoucherReverted,
}) => {
  return useMutation(
    ({ tenantEventId }) => {
      const service = new HudVoucherService();
      return service.moveTenantEventToNextVoucher(
        organizationId,
        propertyId,
        hudVoucherId,
        tenantEventId,
      );
    },
    {
      onSuccess: async () => {
        await invalidateRegularAssistanceQueries();

        if (effectiveSubmissionStatus === 'Submitted') {
          onSubmittedVoucherReverted();
          toastr.warning(
            intl.formatMessage(messages.voucherStatusUpdatedTitle),
            intl.formatMessage(messages.voucherReturnedToDraftWarning),
          );
        }

        toastr.success(
          intl.formatMessage(messages.moveToNextVoucherSuccessTitle),
          intl.formatMessage(messages.moveToNextVoucherSuccessMessage),
        );
      },
      onError: async (e) => {
        const msg =
          e?.message ||
          e?.error ||
          'Failed to move tenant event to next voucher. Please try again.';
        toastr.error('Error', msg);
        await invalidateRegularAssistanceQueries();
      },
    },
  );
};

export default useMoveTenantEventToNextVoucherMutation;
